var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgExclamationCircleFilled = function SvgExclamationCircleFilled(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon / ExclamationCircleFilled"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8 1.89014C4.13438 1.89014 1 5.02451 1 8.89014C1 12.7558 4.13438 15.8901 8 15.8901C11.8656 15.8901 15 12.7558 15 8.89014C15 5.02451 11.8656 1.89014 8 1.89014ZM7.5 5.51514C7.5 5.44639 7.55625 5.39014 7.625 5.39014H8.375C8.44375 5.39014 8.5 5.44639 8.5 5.51514V9.76514C8.5 9.83389 8.44375 9.89014 8.375 9.89014H7.625C7.55625 9.89014 7.5 9.83389 7.5 9.76514V5.51514ZM8 12.3901C7.80374 12.3861 7.61687 12.3054 7.47948 12.1651C7.3421 12.0249 7.26515 11.8364 7.26515 11.6401C7.26515 11.4438 7.3421 11.2554 7.47948 11.1151C7.61687 10.9749 7.80374 10.8941 8 10.8901C8.19626 10.8941 8.38313 10.9749 8.52052 11.1151C8.6579 11.2554 8.73485 11.4438 8.73485 11.6401C8.73485 11.8364 8.6579 12.0249 8.52052 12.1651C8.38313 12.3054 8.19626 12.3861 8 12.3901Z",
    fill: "#FAAD14"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgExclamationCircleFilled);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "ExclamationCircleFilled.3dacf0d6b6ae1a9e6b6fd80e6bf2951d.svg";